export default function ($translate) {
    return {
        KEYS: {
            PER_OCCURRENCE: 'PER_OCCURRENCE',
            PER_PARTICIPANT: 'PER_PARTICIPANT'
        },
        LABELS: {
            PER_OCCURRENCE: $translate.instant('occurrence.Per occurrence'),
            PER_PARTICIPANT: $translate.instant('occurrence.Per participant')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/occurrence/budget/index.js